import React from 'react';
import { Select, Button, Input, DatePicker } from "antd";
import SideNav from "./SideNav";
import API_URL from "../../common/url";
import $ from "../../common/AjaxRequest";
import dictCache from '../../common/dictCache';
import ExportUtil from '../../common/ExportUtil';
import TableC from '../basicElement/TableC';
import moment from "moment";

const { Option } = Select;
const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY-MM';

class Report extends React.Component {
    state = {
        loading: false,
        columnList: [],
        dataList: [],
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 11,
            current: 1,
        },
        businessList: [],
    }

    calculatePaginationTotal = (total, pageSize) => {
        if (total % pageSize == 0) {
            return parseInt(total / pageSize);
        } else {
            return parseInt(total / pageSize) + 1;
        }
    }

    componentDidMount() {
        this.loadData();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.manhour.queryManHourReport,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...sortParams
            },
            type: 'json',
            doneResult: res => {
                const { datas, headers, totalCount } = res;
                pagination.total = totalCount + this.calculatePaginationTotal(totalCount, pageSize);
                this.setState({
                    columnList: headers,
                    dataList: datas,
                    loading: false,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        let url = `${API_URL.export.exportManHourReport}`;
        ExportUtil.export(searchParams, null, url);
    }

    getColumns = () => {
        const columns = [];
        const { columnList } = this.state;
        columnList.map((item, i) => {
            if (i < 2) {
                columns.push({
                    title: item.name,
                    dataIndex: item.key,
                    key: item.key,
                    fixed: 'left',
                    width: 120,
                    sorter: true,
                });
            } else if (i == 2) {
                columns.push({
                    title: item.name,
                    dataIndex: item.key,
                    key: item.key,
                    width: 90,
                    sorter: true,
                });
            } else {
                columns.push({
                    title: item.name,
                    dataIndex: item.key,
                    key: item.key,
                    width: 80,
                });
            }
        });
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        searchParams[key] = value;
        if (key === 'lineOfBusiness') {
            searchParams.secondLineName = undefined;
        }
        this.setState({ searchParams });
    }

    render() {
        const { pagination, loading, sortParams, searchParams, dataList, businessList } = this.state;
        const { lineOfBusiness } = searchParams;

        const secondLineSet = new Set();
        const scrollY = document.documentElement.clientHeight - 140;
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        return (
            <div className="content">
                <SideNav selectKey="report" />
                <div className="main">
                    <div className="search-bar" style={{marginBottom: 10}}>
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">时间</label>
                            <MonthPicker
                                defaultValue={moment()}
                                format={monthFormat}
                                placeholder="请选择"
                                style={{width: 100}}
                                onChange={(date, dateString) => this.handleChange(dateString, 'month')}
                            />
                        </div>
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">项目编号</label>
                            <Input
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                            />
                        </div>
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">项目简称</label>
                            <Input
                                placeholder="请输入"
                                onChange={e => this.handleChange(e.target.value, 'investigationName')}
                            />
                        </div>
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">业务线</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 120}}
                                value={lineOfBusiness}
                                onChange={value => this.handleChange(value, 'lineOfBusiness')}
                            >
                                {businessOption}
                            </Select>
                        </div>
                        <div className="search-item">
                            <label className="ui-label">执行业务线二级分类</label>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{width: 120}}
                                disabled={!lineOfBusiness}
                                value={searchParams.secondLineName}
                                onChange={value => this.handleChange(value, 'secondLineName')}
                            >
                                {secondLineOption}
                            </Select>
                        </div>
                        <div className="search-item">
                            <Button type="primary" onClick={this.search}>搜索</Button>
                            <Button type="primary" onClick={this.export}>导出</Button>
                        </div>
                    </div>
                    <TableC
                        columns={this.getColumns()}
                        data={dataList}
                        pagination={pagination}
                        loading={loading}
                        scrollY={scrollY}
                        sortParams={sortParams}
                        onChange={this.handleTableChange}
                    />
                </div>
            </div>
        );
    }
}

export default Report;



// WEBPACK FOOTER //
// ./src/components/manHour/Report.js